import { mergeProps } from "react-aria";
import { TextArea as AriaTextArea, TextAreaProps } from "react-aria-components";

import { useInputStyles } from "../../styles";

export function _TextArea(props: TextAreaProps) {
  const inputStyles = useInputStyles();

  return <AriaTextArea {...mergeProps(props, { className: inputStyles })} />;
}
